import React from 'react'
import Autoplay1 from '../../../assets/customPlayer/autoplay/autoplay1'
import Autoplay2 from '../../../assets/customPlayer/autoplay/autoplay2'
import Autoplay3 from '../../../assets/customPlayer/autoplay/autoplay3'
import Autoplay4 from '../../../assets/customPlayer/autoplay/autoplay4'

const AutoplayButton = ({ color = '#fff', iconType }) => {
  let icons = {
    AUTOPLAY1: (
      <>
        <Autoplay1 color={color} />
      </>
    ),
    AUTOPLAY2: (
      <>
        <Autoplay2 color={color} />
      </>
    ),
    AUTOPLAY3: (
      <>
        <Autoplay3 color={color} />
      </>
    ),
    AUTOPLAY4: (
      <>
        <Autoplay4 color={color} />
      </>
    ),
  }

  return (
    <div style={{ maxWidth: '15px' }} className="flex justify-center items-center w-auto h-full">
      {icons[iconType]}
    </div>
  )
}

export default AutoplayButton
